import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnDestroy, Output, Renderer2, ViewChild } from '@angular/core';
import { MaxBrainTag } from 'app/library/tag/models/tag.model';
import { TagsCardService } from './tags-card.service';

@Component({
    selector: 'app-tags-card',
    templateUrl: './tags-card.component.html',
    styleUrls: ['./tags-card.component.scss'],
})
export class TagsCardComponent implements AfterViewInit, OnDestroy {
    @Input()
    tags: MaxBrainTag[];

    // caller passes a template ref to a DOM element (e.g. #more)
    @Input()
    target: HTMLElement;

    @Output()
    clickedTag = new EventEmitter<MaxBrainTag>();

    hide = true;

    @ViewChild('card')
    card: ElementRef<HTMLElement>;

    private _isCursorOnCard = false;
    private _isCursorOnTarget = false;
    private _hideTimeout: ReturnType<typeof setTimeout> | null = null;
    private _unlisteners: Array<() => void> = [];

    constructor(private _renderer: Renderer2, private service: TagsCardService, private _cd: ChangeDetectorRef) {}

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.listenEvents();
        });
    }

    ngOnDestroy(): void {
        this._clearHideTimeout();
        this._unlisteners.forEach((unlisten) => unlisten());
        this._unlisteners = [];
    }

    listenEvents(): void {
        if (!this.target || !this.card?.nativeElement) {
            return;
        }

        this._unlisteners.push(
            this._renderer.listen(this.target, 'mouseenter', () => {
                this._isCursorOnTarget = true;
                this._clearHideTimeout();
                this.service.show(this);
                this._cd.detectChanges();
            })
        );

        this._unlisteners.push(
            this._renderer.listen(this.target, 'mouseleave', () => {
                this._isCursorOnTarget = false;
                this._scheduleHide();
            })
        );

        this._unlisteners.push(
            this._renderer.listen(this.card.nativeElement, 'mouseenter', () => {
                this._isCursorOnCard = true;
                this._clearHideTimeout();
                this.service.show(this);
                this._cd.detectChanges();
            })
        );

        this._unlisteners.push(
            this._renderer.listen(this.card.nativeElement, 'mouseleave', () => {
                this._isCursorOnCard = false;
                this._scheduleHide();
            })
        );
    }

    filterByTag(tag: MaxBrainTag): void {
        this.clickedTag.emit(tag);
    }

    private _scheduleHide(): void {
        this._clearHideTimeout();
        this._hideTimeout = setTimeout(() => {
            if (!this._isCursorOnCard && !this._isCursorOnTarget && !this.hide) {
                this.service.hide(this);
                this._cd.detectChanges();
            }
        }, 150);
    }

    private _clearHideTimeout(): void {
        if (this._hideTimeout) {
            clearTimeout(this._hideTimeout);
            this._hideTimeout = null;
        }
    }
}
